module.exports = __webpack_public_path__ + "assets/travelingAbroad_programs-08d6352f194b8bb37d7ac71d24bb21ea.pdf";